// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.About_container__wKgqM {
    height: 180vh;
    background-color: #040404; 
  }
  
  .About_wrapper__\\+8Fcn {
    height: 100vh;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .About_textContainer__9qWpD {
    max-width: 1200px; 
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .About_text__VHQSN {
    max-width: 80%; 
    font-size: 3rem; 
    font-weight: 600;
    text-align: center; 
  }

  @media (max-width: 768px) {
    .About_text__VHQSN {
        font-size: 2rem;
        max-width: 90%;
    }
  }
  
  .About_line__n\\+1J4 {
    line-height: 1.5; 
  }
  
  .About_normal__EZWYO {
    color: #202020; 
  }
  
  .About_colored__QcxzI {
    color: #fff; 
  }`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/About/About.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE;QACI,eAAe;QACf,cAAc;IAClB;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb","sourcesContent":[".container {\n    height: 180vh;\n    background-color: #040404; \n  }\n  \n  .wrapper {\n    height: 100vh;\n    position: sticky;\n    top: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .textContainer {\n    max-width: 1200px; \n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .text {\n    max-width: 80%; \n    font-size: 3rem; \n    font-weight: 600;\n    text-align: center; \n  }\n\n  @media (max-width: 768px) {\n    .text {\n        font-size: 2rem;\n        max-width: 90%;\n    }\n  }\n  \n  .line {\n    line-height: 1.5; \n  }\n  \n  .normal {\n    color: #202020; \n  }\n  \n  .colored {\n    color: #fff; \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `About_container__wKgqM`,
	"wrapper": `About_wrapper__+8Fcn`,
	"textContainer": `About_textContainer__9qWpD`,
	"text": `About_text__VHQSN`,
	"line": `About_line__n+1J4`,
	"normal": `About_normal__EZWYO`,
	"colored": `About_colored__QcxzI`
};
export default ___CSS_LOADER_EXPORT___;
